import { render, staticRenderFns } from "./message-text.vue?vue&type=template&id=7767f0fa&scoped=true"
import script from "./message-text.vue?vue&type=script&lang=ts"
export * from "./message-text.vue?vue&type=script&lang=ts"
import style0 from "./message-text.vue?vue&type=style&index=0&id=7767f0fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7767f0fa",
  null
  
)

export default component.exports